export const languageMap = [

  // {
  //   country: 'Korea, Republic of',
  //   code: 'KR',
  //   continent: 'Popular',
  //   name: '🇰🇷 KR'
  // },
  // {
  //   country: 'Japan',
  //   code: 'JP',
  //   continent: 'Popular',
  //   name: '🇯🇵 JP'
  // },
  // {
  //   country: 'US',
  //   code: 'US',
  //   continent: 'Popular',
  //   name: '🇺🇸 US'
    
  // },
  // {
  //   country: 'India',
  //   code: 'IN',
  //   continent: 'Popular',
  //   name: '🇮🇳 IN'
  // },
  // {
  //   country: 'Germany',
  //   code: 'DE',
  //   continent: 'Popular',
  //   name: '🇩🇪 DE'
  // },
  // {
  //   country: 'Egypt',
  //   code: 'EG',
  //   continent: 'Popular',
  //   name: '🇪🇬 EG'
  // },
  // {
  //   country: 'Brazil',
  //   code: 'BR',
  //   continent: 'Popular',
  //   name: '🇧🇷 BR'
  // },
 
  // {
  //   country: 'Russian Federation',
  //   code: 'RU',
  //   continent: 'Popular',
  //   name: '🇷🇺 RU'
  // },
  // {
  //   country: 'France',
  //   code: 'FR',
  //   continent: 'Popular',
  //   name: '🇫🇷 FR'
  // },
  // {
  //   country: 'Turkey',
  //   code: 'TR',
  //   continent: 'Popular',
  //   name: '🇹🇷 TR'
  // },
  
  // {
  //   country: 'Vietnam',
  //   code: 'VN',
  //   continent: 'Popular',
  //   name: '🇻🇳 VN'
  // },
  
  // {
  //   country: 'Thailand',
  //   code: 'TH',
  //   continent: 'Popular',
  //   name: '🇹🇭 TH'
  // },
  // {
  //   country: 'Indonesia',
  //   code: 'ID',
  //   continent: 'Popular',
  //   name: '🇮🇩 ID'
  // },
  // {
  //   country: 'Mexico',
  //   code: 'MX',
  //   continent: 'Popular',
  //   name: '🇲🇽 MX'
  // },
  

  // 인기 국가 
  
    {
      country: 'Korea, Republic of',
      code: 'KR',
      continent: 'Asia',
      name: '🇰🇷 KR',
      ko: '대한민국'
    },
    {
      country: 'Japan',
      code: 'JP',
      continent: 'Asia',
      name: '🇯🇵 JP',
      ko: '일본'
    },
    {
      country: 'US',
      code: 'US',
      continent: 'North America',
      name: '🇺🇸 US',
      ko: '미국'
    },
    {
      country: 'Vietnam',
      code: 'VN',
      continent: 'Asia',
      name: '🇻🇳 VN',
      ko: '베트남'
    },
    {
      country: 'India',
      code: 'IN',
      continent: 'Asia',
      name: '🇮🇳 IN',
      ko: '인도'
    },
    {
      country: 'Thailand',
      code: 'TH',
      continent: 'Asia',
      name: '🇹🇭 TH',
      ko: '태국'
    },
    {
      country: 'Indonesia',
      code: 'ID',
      continent: 'Asia',
      name: '🇮🇩 ID',
      ko: '인도네시아'
    },
    {
      country: 'Mexico',
      code: 'MX',
      continent: 'North America',
      name: '🇲🇽 MX',
      ko: '멕시코'
    },
    {
      country: 'Egypt',
      code: 'EG',
      continent: 'Africa',
      name: '🇪🇬 EG',
      ko: '이집트'
    },
    {
      country: 'Brazil',
      code: 'BR',
      continent: 'South America',
      name: '🇧🇷 BR',
      ko: '브라질'
    },
    {
      country: 'Russian Federation',
      code: 'RU',
      continent: 'Europe',
      name: '🇷🇺 RU',
      ko: '러시아'
    },
  
    // ------------------
    {
      country: 'Bangladesh',
      code: 'BD',
      continent: 'Asia',
      name: '🇧🇩 BD',
      ko: '방글라데시'
    },
    {
      country: 'Pakistan',
      code: 'PK',
      continent: 'Asia',
      name: '🇵🇰 PK',
      ko: '파키스탄'
    },
    {
      country: 'Germany',
      code: 'DE',
      continent: 'Europe',
      name: '🇩🇪 DE',
      ko: '독일'
    },
    {
      country: 'France',
      code: 'FR',
      continent: 'Europe',
      name: '🇫🇷 FR',
      ko: '프랑스'
    },
    {
      country: 'Turkey',
      code: 'TR',
      continent: 'Asia',
      name: '🇹🇷 TR',
      ko: '튀르키예'
    },
    {
      country: 'Iran, Islamic Republic of',
      code: 'IR',
      continent: 'Asia',
      name: '🇮🇷 IR',
      ko: '이란'
    },
    {
      country: 'Italy',
      code: 'IT',
      continent: 'Europe',
      name: '🇮🇹 IT',
      ko: '이탈리아'
    },
    {
      country: 'China',
      code: 'CN',
      continent: 'Asia',
      name: '🇨🇳 CN',
      ko: '중국'
    },
    {
      country: 'Nigeria',
      code: 'NG',
      continent: 'Africa',
      name: '🇳🇬 NG',
      ko: '나이지리아'
    },
    {
      country: 'Philippines',
      code: 'PH',
      continent: 'Asia',
      name: '🇵🇭 PH',
      ko: '필리핀'
    },
    {
      country: 'Congo, Democratic Republic of the',
      code: 'CD',
      continent: 'Africa',
      name: '🇨🇩 CD',
      ko: '콩고 민주 공화국'
    },
    {
      country: 'Ethiopia',
      code: 'ET',
      continent: 'Africa',
      name: '🇪🇹 ET',
      ko: '에티오피아'
    },
    {
      country: 'United Kingdom',
      code: 'GB',
      continent: 'Europe',
      name: '🇬🇧 GB',
      ko: '영국'
    },
    {
      country: 'United Republic of Tanzania',
      code: 'TZ',
      continent: 'Africa',
      name: '🇹🇿 TZ',
      ko: '탄자니아'
    },
    {
      country: 'South Africa',
      code: 'ZA',
      continent: 'Africa',
      name: '🇿🇦 ZA',
      ko: '남아프리카공화국'
    },
    {
      country: 'Kenya',
      code: 'KE',
      continent: 'Africa',
      name: '🇰🇪 KE',
      ko: '케냐'
    },
    {
      country: 'Colombia',
      code: 'CO',
      continent: 'South America',
      name: '🇨🇴 CO',
      ko: '콜롬비아'
    },
    {
      country: 'Sudan',
      code: 'SD',
      continent: 'Africa',
      name: '🇸🇩 SD',
      ko: '수단'
    },
    {
      country: 'Myanmar',
      code: 'MM',
      continent: 'Asia',
      name: '🇲🇲 MM',
      ko: '미얀마'
    },
    {
      country: 'Spain',
      code: 'ES',
      continent: 'Europe',
      name: '🇪🇸 ES',
      ko: '스페인'
    },
    {
      country: 'Algeria',
      code: 'DZ',
      continent: 'Africa',
      name: '🇩🇿 DZ',
      ko: '알제리'
    },
    {
      country: 'Argentina',
      code: 'AR',
      continent: 'South America',
      name: '🇦🇷 AR',
      ko: '아르헨티나'
    },
    {
      country: 'Iraq',
      code: 'IQ',
      continent: 'Asia',
      name: '🇮🇶 IQ',
      ko: '이라크'
    },
    {
      country: 'Uganda',
      code: 'UG',
      continent: 'Africa',
      name: '🇺🇬 UG',
      ko: '우간다'
    },
    {
      country: 'Afghanistan',
      code: 'AF',
      continent: 'Asia',
      name: '🇦🇫 AF',
      ko: '아프가니스탄'
    },
    {
      country: 'Canada',
      code: 'CA',
      continent: 'North America',
      name: '🇨🇦 CA',
      ko: '캐나다'
    },
    {
      country: 'Uzbekistan',
      code: 'UZ',
      continent: 'Asia',
      name: '🇺🇿 UZ',
      ko: '우즈베키스탄'
    },
    {
      country: 'Poland',
      code: 'PL',
      continent: 'Europe',
      name: '🇵🇱 PL',
      ko: '폴란드'
    },
    {
      country: 'Morocco',
      code: 'MA',
      continent: 'Africa',
      name: '🇲🇦 MA',
      ko: '모로코'
    },
    {
      country: 'Angola',
      code: 'AO',
      continent: 'Africa',
      name: '🇦🇴 AO',
      ko: '앙골라'
    },
    {
      country: 'Saudi Arabia',
      code: 'SA',
      continent: 'Asia',
      name: '🇸🇦 SA',
      ko: '사우디아라비아'
    },
    {
      country: 'Peru',
      code: 'PE',
      continent: 'South America',
      name: '🇵🇪 PE',
      ko: '페루'
    },
    {
      country: 'Malaysia',
      code: 'MY',
      continent: 'Asia',
      name: '🇲🇾 MY',
      ko: '말레이시아'
    },
    {
      country: 'Mozambique',
      code: 'MZ',
      continent: 'Africa',
      name: '🇲🇿 MZ',
      ko: '모잠비크'
    },
    {
      country: 'Ghana',
      code: 'GH',
      continent: 'Africa',
      name: '🇬🇭 GH',
      ko: '가나'
    },
    {
      country: 'Ukraine',
      code: 'UA',
      continent: 'Europe',
      name: '🇺🇦 UA',
      ko: '우크라이나'
    },
    {
      country: 'Yemen',
      code: 'YE',
      continent: 'Asia',
      name: '🇾🇪 YE',
      ko: '예멘'
    },
    {
      country: 'Madagascar',
      code: 'MG',
      continent: 'Africa',
      name: '🇲🇬 MG',
      ko: '마다가스카르'
    },
    {
      country: "Cote d'Ivoire",
      code: 'CI',
      continent: 'Africa',
      name: '🇨🇮 CI',
      ko: '코트디부아르'
    },
    {
      country: 'Nepal',
      code: 'NP',
      continent: 'Asia',
      name: '🇳🇵 NP',
      ko: '네팔'
    },
    {
      country: 'Cameroon',
      code: 'CM',
      continent: 'Africa',
      name: '🇨🇲 CM',
      ko: '카메룬'
    },
    {
      country: 'Venezuela',
      code: 'VE',
      continent: 'South America',
      name: '🇻🇪 VE',
      ko: '베네수엘라'
    },
    {
      country: 'Australia',
      code: 'AU',
      continent: 'Oceania',
      name: '🇦🇺 AU',
      ko: '호주'
    },
    {
      country: 'Niger',
      code: 'NE',
      continent: 'Africa',
      name: '🇳🇪 NE',
      ko: '니제르'
    },
    {
      country: "Korea, Democratic People's Republic of",
      code: 'KP',
      continent: 'Asia',
      name: '🇰🇵 KP',
      ko: '북한'
    },
    {
      country: 'Syrian Arab Republic',
      code: 'SY',
      continent: 'Asia',
      name: '🇸🇾 SY',
      ko: '시리아'
    },
    {
      country: 'Burkina Faso',
      code: 'BF',
      continent: 'Africa',
      name: '🇧🇫 BF',
      ko: '부르키나파소'
    },
    {
      country: 'Taiwan, Province of China',
      code: 'TW',
      continent: 'Asia',
      name: '🇹🇼 TW',
      ko: '대만'
    },
    {
      country: 'Mali',
      code: 'ML',
      continent: 'Africa',
      name: '🇲🇱 ML',
      ko: '말리'
    },
    {
      country: 'Sri Lanka',
      code: 'LK',
      continent: 'Asia',
      name: '🇱🇰 LK',
      ko: '스리랑카'
    },
    {
      country: 'Malawi',
      code: 'MW',
      continent: 'Africa',
      name: '🇲🇼 MW',
      ko: '말라위'
    },
    {
      country: 'Kazakhstan',
      code: 'KZ',
      continent: 'Asia',
      name: '🇰🇿 KZ',
      ko: '카자흐스탄'
    },
    {
      country: 'Chile',
      code: 'CL',
      continent: 'South America',
      name: '🇨🇱 CL',
      ko: '칠레'
    },
    {
      country: 'Zambia',
      code: 'ZM',
      continent: 'Africa',
      name: '🇿🇲 ZM',
      ko: '잠비아'
    },
    {
      country: 'Somalia',
      code: 'SO',
      continent: 'Africa',
      name: '🇸🇴 SO',
      ko: '소말리아'
    },
    {
      country: 'Chad',
      code: 'TD',
      continent: 'Africa',
      name: '🇹🇩 TD',
      ko: '차드'
    },
    {
      country: 'Romania',
      code: 'RO',
      continent: 'Europe',
      name: '🇷🇴 RO',
      ko: '루마니아'
    },
    {
      country: 'Senegal',
      code: 'SN',
      continent: 'Africa',
      name: '🇸🇳 SN',
      ko: '세네갈'
    },
    {
      country: 'Ecuador',
      code: 'EC',
      continent: 'South America',
      name: '🇪🇨 EC',
      ko: '에콰도르'
    },
    {
      country: 'Netherlands',
      code: 'NL',
      continent: 'Europe',
      name: '🇳🇱 NL',
      ko: '네덜란드'
    },
    {
      country: 'Guatemala',
      code: 'GT',
      continent: 'North America',
      name: '🇬🇹 GT',
      ko: '과테말라'
    },
    {
      country: 'Cambodia',
      code: 'KH',
      continent: 'Asia',
      name: '🇰🇭 KH',
      ko: '캄보디아'
    },
    {
      country: 'Zimbabwe',
      code: 'ZW',
      continent: 'Africa',
      name: '🇿🇼 ZW',
      ko: '짐바브웨'
    },
    {
      country: 'South Sudan',
      code: 'SS',
      continent: 'Africa',
      name: '🇸🇸 SS',
      ko: '남수단'
    },
    {
      country: 'Guinea',
      code: 'GN',
      continent: 'Africa',
      name: '🇬🇳 GN',
      ko: '기니'
    },
    {
      country: 'Rwanda',
      code: 'RW',
      continent: 'Africa',
      name: '🇷🇼 RW',
      ko: '르완다'
    },
    {
      country: 'Benin',
      code: 'BJ',
      continent: 'Africa',
      name: '🇧🇯 BJ',
      ko: '베냉'
    },
    {
      country: 'Burundi',
      code: 'BI',
      continent: 'Africa',
      name: '🇧🇮 BI',
      ko: '부룬디'
    },
    {
      country: 'Tunisia',
      code: 'TN',
      continent: 'Africa',
      name: '🇹🇳 TN',
      ko: '튀니지'
    },
    {
      country: 'Haiti',
      code: 'HT',
      continent: 'North America',
      name: '🇭🇹 HT',
      ko: '아이티'
    },
    {
      country: 'Belgium',
      code: 'BE',
      continent: 'Europe',
      name: '🇧🇪 BE',
      ko: '벨기에'
    },
    {
      country: 'Papua New Guinea',
      code: 'PG',
      continent: 'Oceania',
      name: '🇵🇬 PG',
      ko: '파푸아뉴기니'
    },
    {
      country: 'Jordan',
      code: 'JO',
      continent: 'Asia',
      name: '🇯🇴 JO',
      ko: '요르단'
    },
    {
      country: 'Bolivia',
      code: 'BO',
      continent: 'South America',
      name: '🇧🇴 BO',
      ko: '볼리비아'
    },
    {
      country: 'United Arab Emirates',
      code: 'AE',
      continent: 'Asia',
      name: '🇦🇪 AE',
      ko: '아랍에미리트'
    },
    {
      country: 'Czech Republic',
      code: 'CZ',
      continent: 'Europe',
      name: '🇨🇿 CZ',
      ko: '체코'
    },
    {
      country: 'Dominican Republic',
      code: 'DO',
      continent: 'North America',
      name: '🇩🇴 DO',
      ko: '도미니카 공화국'
    },
    {
      country: 'Portugal',
      code: 'PT',
      continent: 'Europe',
      name: '🇵🇹 PT',
      ko: '포르투갈'
    },
    {
      country: 'Sweden',
      code: 'SE',
      continent: 'Europe',
      name: '🇸🇪 SE',
      ko: '스웨덴'
    },
    {
      country: 'Tajikistan',
      code: 'TJ',
      continent: 'Asia',
      name: '🇹🇯 TJ',
      ko: '타지키스탄'
    },
    {
      country: 'Greece',
      code: 'GR',
      continent: 'Europe',
      name: '🇬🇷 GR',
      ko: '그리스'
    },
    {
      country: 'Azerbaijan',
      code: 'AZ',
      continent: 'Asia',
      name: '🇦🇿 AZ',
      ko: '아제르바이잔'
    },
    {
      country: 'Israel',
      code: 'IL',
      continent: 'Asia',
      name: '🇮🇱 IL',
      ko: '이스라엘'
    },
    {
      country: 'Honduras',
      code: 'HN',
      continent: 'North America',
      name: '🇭🇳 HN',
      ko: '온두라스'
    },
    {
      country: 'Cuba',
      code: 'CU',
      continent: 'North America',
      name: '🇨🇺 CU',
      ko: '쿠바'
    },
    {
      country: 'Hungary',
      code: 'HU',
      continent: 'Europe',
      name: '🇭🇺 HU',
      ko: '헝가리'
    },
    {
      country: 'Austria',
      code: 'AT',
      continent: 'Europe',
      name: '🇦🇹 AT',
      ko: '오스트리아'
    },
    {
      country: 'Belarus',
      code: 'BY',
      continent: 'Europe',
      name: '🇧🇾 BY',
      ko: '벨라루스'
    },
    {
      country: 'Switzerland',
      code: 'CH',
      continent: 'Europe',
      name: '🇨🇭 CH',
      ko: '스위스'
    },
    {
      country: 'Sierra Leone',
      code: 'SL',
      continent: 'Africa',
      name: '🇸🇱 SL',
      ko: '시에라리온'
    },
    {
      country: 'Togo',
      code: 'TG',
      continent: 'Africa',
      name: '🇹🇬 TG',
      ko: '토고'
    },
    {
      country: "Lao People's Democratic Republic",
      code: 'LA',
      continent: 'Asia',
      name: '🇱🇦 LA',
      ko: '라오스'
    },
    {
      country: 'Hong Kong',
      code: 'HK',
      continent: 'Asia',
      name: '🇭🇰 HK',
      ko: '홍콩'
    },
    {
      country: 'Libya',
      code: 'LY',
      continent: 'Africa',
      name: '🇱🇾 LY',
      ko: '리비아'
    },
    {
      country: 'Kyrgyzstan',
      code: 'KG',
      continent: 'Asia',
      name: '🇰🇬 KG',
      ko: '키르기스스탄'
    },
    {
      country: 'Turkmenistan',
      code: 'TM',
      continent: 'Asia',
      name: '🇹🇲 TM',
      ko: '투르크메니스탄'
    },
    {
      country: 'Nicaragua',
      code: 'NI',
      continent: 'North America',
      name: '🇳🇮 NI',
      ko: '니카라과'
    },
    {
      country: 'Serbia',
      code: 'RS',
      continent: 'Europe',
      name: '🇷🇸 RS',
      ko: '세르비아'
    },
    {
      country: 'Central African Republic',
      code: 'CF',
      continent: 'Africa',
      name: '🇨🇫 CF',
      ko: '중앙아프리카공화국'
    },
    {
      country: 'Bulgaria',
      code: 'BG',
      continent: 'Europe',
      name: '🇧🇬 BG',
      ko: '불가리아'
    },
    {
      country: 'Congo, Republic of the',
      code: 'CG',
      continent: 'Africa',
      name: '🇨🇬 CG',
      ko: '콩고 공화국'
    },
    {
      country: 'Singapore',
      code: 'SG',
      continent: 'Asia',
      name: '🇸🇬 SG',
      ko: '싱가포르'
    },
    {
      country: 'Paraguay',
      code: 'PY',
      continent: 'South America',
      name: '🇵🇾 PY',
      ko: '파라과이'
    },
    {
      country: 'El Salvador',
      code: 'SV',
      continent: 'North America',
      name: '🇸🇻 SV',
      ko: '엘살바도르'
    },
    {
      country: 'Denmark',
      code: 'DK',
      continent: 'Europe',
      name: '🇩🇰 DK',
      ko: '덴마크'
    },
    {
      country: 'Finland',
      code: 'FI',
      continent: 'Europe',
      name: '🇫🇮 FI',
      ko: '핀란드'
    },
    {
      country: 'Norway',
      code: 'NO',
      continent: 'Europe',
      name: '🇳🇴 NO',
      ko: '노르웨이'
    },
    {
      country: 'Lebanon',
      code: 'LB',
      continent: 'Asia',
      name: '🇱🇧 LB',
      ko: '레바논'
    },
    {
      country: 'Palestine, State of',
      code: 'PS',
      continent: 'Asia',
      name: '🇵🇸 PS',
      ko: '팔레스타인'
    },
    {
      country: 'Ireland',
      code: 'IE',
      continent: 'Europe',
      name: '🇮🇪 IE',
      ko: '아일랜드'
    },
    {
      country: 'Slovakia',
      code: 'SK',
      continent: 'Europe',
      name: '🇸🇰 SK',
      ko: '슬로바키아'
    },
    {
      country: 'Oman',
      code: 'OM',
      continent: 'Asia',
      name: '🇴🇲 OM',
      ko: '오만'
    },
    {
      country: 'New Zealand',
      code: 'NZ',
      continent: 'Oceania',
      name: '🇳🇿 NZ',
      ko: '뉴질랜드'
    },
    {
      country: 'Costa Rica',
      code: 'CR',
      continent: 'North America',
      name: '🇨🇷 CR',
      ko: '코스타리카'
    },
    {
      country: 'Liberia',
      code: 'LR',
      continent: 'Africa',
      name: '🇱🇷 LR',
      ko: '라이베리아'
    },
    {
      country: 'Mauritania',
      code: 'MR',
      continent: 'Africa',
      name: '🇲🇷 MR',
      ko: '모리타니'
    },
    {
      country: 'Kuwait',
      code: 'KW',
      continent: 'Asia',
      name: '🇰🇼 KW',
      ko: '쿠웨이트'
    },
    {
      country: 'Panama',
      code: 'PA',
      continent: 'North America',
      name: '🇵🇦 PA',
      ko: '파나마'
    },
    {
      country: 'Georgia',
      code: 'GE',
      continent: 'Asia',
      name: '🇬🇪 GE',
      ko: '조지아'
    },
    {
      country: 'Croatia',
      code: 'HR',
      continent: 'Europe',
      name: '🇭🇷 HR',
      ko: '크로아티아'
    },
    {
      country: 'Eritrea',
      code: 'ER',
      continent: 'Africa',
      name: '🇪🇷 ER',
      ko: '에리트레아'
    },
    {
      country: 'Mongolia',
      code: 'MN',
      continent: 'Asia',
      name: '🇲🇳 MN',
      ko: '몽골'
    },
    {
      country: 'Uruguay',
      code: 'UY',
      continent: 'South America',
      name: '🇺🇾 UY',
      ko: '우루과이'
    },
    {
      country: 'Bosnia and Herzegovina',
      code: 'BA',
      continent: 'Europe',
      name: '🇧🇦 BA',
      ko: '보스니아 헤르체고비나'
    },
    {
      country: 'Puerto Rico',
      code: 'PR',
      continent: 'North America',
      name: '🇵🇷 PR',
      ko: '푸에르토리코'
    },
    {
      country: 'Qatar',
      code: 'QA',
      continent: 'Asia',
      name: '🇶🇦 QA',
      ko: '카타르'
    },
    {
      country: 'Armenia',
      code: 'AM',
      continent: 'Asia',
      name: '🇦🇲 AM',
      ko: '아르메니아'
    },
    {
      country: 'Namibia',
      code: 'NA',
      continent: 'Africa',
      name: '🇳🇦 NA',
      ko: '나미비아'
    },
    {
      country: 'Lithuania',
      code: 'LT',
      continent: 'Europe',
      name: '🇱🇹 LT',
      ko: '리투아니아'
    },
    {
      country: 'Jamaica',
      code: 'JM',
      continent: 'North America',
      name: '🇯🇲 JM',
      ko: '자메이카'
    },
    {
      country: 'Moldova, Republic of',
      code: 'MD',
      continent: 'Europe',
      name: '🇲🇩 MD',
      ko: '몰도바'
    },
    {
      country: 'Gabon',
      code: 'GA',
      continent: 'Africa',
      name: '🇬🇦 GA',
      ko: '가봉'
    },
    {
      country: 'Gambia',
      code: 'GM',
      continent: 'Africa',
      name: '🇬🇲 GM',
      ko: '감비아'
    },
    {
      country: 'Albania',
      code: 'AL',
      continent: 'Europe',
      name: '🇦🇱 AL',
      ko: '알바니아'
    },
    {
      country: 'Botswana',
      code: 'BW',
      continent: 'Africa',
      name: '🇧🇼 BW',
      ko: '보츠와나'
    },
    {
      country: 'Slovenia',
      code: 'SI',
      continent: 'Europe',
      name: '🇸🇮 SI',
      ko: '슬로베니아'
    },
    {
      country: 'Lesotho',
      code: 'LS',
      continent: 'Africa',
      name: '🇱🇸 LS',
      ko: '레소토'
    },
    {
      country: 'Latvia',
      code: 'LV',
      continent: 'Europe',
      name: '🇱🇻 LV',
      ko: '라트비아'
    },
    {
      country: 'Macedonia, the Former Yugoslav Republic of',
      code: 'MK',
      continent: 'Europe',
      name: '🇲🇰 MK',
      ko: '북마케도니아'
    },
    {
      country: 'Guinea-Bissau',
      code: 'GW',
      continent: 'Africa',
      name: '🇬🇼 GW',
      ko: '기니비사우'
    },
    {
      country: 'Equatorial Guinea',
      code: 'GQ',
      continent: 'Africa',
      name: '🇬🇶 GQ',
      ko: '적도 기니'
    },
    {
      country: 'Bahrain',
      code: 'BH',
      continent: 'Asia',
      name: '🇧🇭 BH',
      ko: '바레인'
    },
    {
      country: 'Kosovo',
      code: 'XK',
      continent: 'Europe',
      name: '🇽🇰 XK',
      ko: '코소보'
    },
    {
      country: 'Cyprus',
      code: 'CY',
      continent: 'Asia',
      name: '🇨🇾 CY',
      ko: '키프로스'
    },
    {
      country: 'Timor-Leste',
      code: 'TL',
      continent: 'Asia',
      name: '🇹🇱 TL',
      ko: '동티모르'
    },
    {
      country: 'Estonia',
      code: 'EE',
      continent: 'Europe',
      name: '🇪🇪 EE',
      ko: '에스토니아'
    },
    {
      country: 'Trinidad and Tobago',
      code: 'TT',
      continent: 'North America',
      name: '🇹🇹 TT',
      ko: '트리니다드 토바고'
    },
    {
      country: 'Mauritius',
      code: 'MU',
      continent: 'Africa',
      name: '🇲🇺 MU',
      ko: '모리셔스'
    },
    {
      country: 'Swaziland',
      code: 'SZ',
      continent: 'Africa',
      name: '🇸🇿 SZ',
      ko: '에스와티니'
    },
    {
      country: 'Djibouti',
      code: 'DJ',
      continent: 'Africa',
      name: '🇩🇯 DJ',
      ko: '지부티'
    },
    {
      country: 'Comoros',
      code: 'KM',
      continent: 'Africa',
      name: '🇰🇲 KM',
      ko: '코모로'
    },
    {
      country: 'Fiji',
      code: 'FJ',
      continent: 'Oceania',
      name: '🇫🇯 FJ',
      ko: '피지'
    },
    {
      country: 'Reunion',
      code: 'RE',
      continent: 'Africa',
      name: '🇷🇪 RE',
      ko: '레위니옹'
    },
    {
      country: 'Bhutan',
      code: 'BT',
      continent: 'Asia',
      name: '🇧🇹 BT',
      ko: '부탄'
    },
    {
      country: 'Guyana',
      code: 'GY',
      continent: 'South America',
      name: '🇬🇾 GY',
      ko: '가이아나'
    },
    {
      country: 'Solomon Islands',
      code: 'SB',
      continent: 'Oceania',
      name: '🇸🇧 SB',
      ko: '솔로몬 제도'
    },
    {
      country: 'Macao',
      code: 'MO',
      continent: 'Asia',
      name: '🇲🇴 MO',
      ko: '마카오'
    },
    {
      country: 'Luxembourg',
      code: 'LU',
      continent: 'Europe',
      name: '🇱🇺 LU',
      ko: '룩셈부르크'
    },
    {
      country: 'Montenegro',
      code: 'ME',
      continent: 'Europe',
      name: '🇲🇪 ME',
      ko: '몬테네그로'
    },
    {
      country: 'Suriname',
      code: 'SR',
      continent: 'South America',
      name: '🇸🇷 SR',
      ko: '수리남'
    },
    {
      country: 'Western Sahara',
      code: 'EH',
      continent: 'Africa',
      name: '🇪🇭 EH',
      ko: '서사하라'
    },
    {
      country: 'Malta',
      code: 'MT',
      continent: 'Europe',
      name: '🇲🇹 MT',
      ko: '몰타'
    },
    {
      country: 'Maldives',
      code: 'MV',
      continent: 'Asia',
      name: '🇲🇻 MV',
      ko: '몰디브'
    },
    {
      country: 'Cape Verde',
      code: 'CV',
      continent: 'Africa',
      name: '🇨🇻 CV',
      ko: '카보베르데'
    },
    {
      country: 'Brunei Darussalam',
      code: 'BN',
      continent: 'Asia',
      name: '🇧🇳 BN',
      ko: '브루나이'
    },
    {
      country: 'Belize',
      code: 'BZ',
      continent: 'North America',
      name: '🇧🇿 BZ',
      ko: '벨리즈'
    },
    {
      country: 'Bahamas',
      code: 'BS',
      continent: 'North America',
      name: '🇧🇸 BS',
      ko: '바하마'
    },
    {
      country: 'Iceland',
      code: 'IS',
      continent: 'Europe',
      name: '🇮🇸 IS',
      ko: '아이슬란드'
    },
    {
      country: 'Guadeloupe',
      code: 'GP',
      continent: 'North America',
      name: '🇬🇵 GP',
      ko: '과들루프'
    },
    {
      country: 'Martinique',
      code: 'MQ',
      continent: 'North America',
      name: '🇲🇶 MQ',
      ko: '마르티니크'
    },
    {
      country: 'Vanuatu',
      code: 'VU',
      continent: 'Oceania',
      name: '🇻🇺 VU',
      ko: '바누아투'
    },
    {
      country: 'Mayotte',
      code: 'YT',
      continent: 'Africa',
      name: '🇾🇹 YT',
      ko: '마요트'
    },
    {
      country: 'French Guiana',
      code: 'GF',
      continent: 'South America',
      name: '🇬🇫 GF',
      ko: '프랑스령 기아나'
    },
    {
      country: 'French Polynesia',
      code: 'PF',
      continent: 'Oceania',
      name: '🇵🇫 PF',
      ko: '프랑스령 폴리네시아'
    },
    {
      country: 'Barbados',
      code: 'BB',
      continent: 'North America',
      name: '🇧🇧 BB',
      ko: '바베이도스'
    },
    {
      country: 'New Caledonia',
      code: 'NC',
      continent: 'Oceania',
      name: '🇳🇨 NC',
      ko: '뉴칼레도니아'
    },
    {
      country: 'Sao Tome and Principe',
      code: 'ST',
      continent: 'Africa',
      name: '🇸🇹 ST',
      ko: '상투메 프린시페'
    },
    {
      country: 'Samoa',
      code: 'WS',
      continent: 'Oceania',
      name: '🇼🇸 WS',
      ko: '사모아'
    },
    {
      country: 'Saint Lucia',
      code: 'LC',
      continent: 'North America',
      name: '🇱🇨 LC',
      ko: '세인트루시아'
    },
    {
      country: 'Curacao',
      code: 'CW',
      continent: 'North America',
      name: '🇨🇼 CW',
      ko: '퀴라소'
    },
    {
      country: 'Guam',
      code: 'GU',
      continent: 'Oceania',
      name: '🇬🇺 GU',
      ko: '괌'
    },
    {
      country: 'Seychelles',
      code: 'SC',
      continent: 'Africa',
      name: '🇸🇨 SC',
      ko: '세이셸'
    },
    {
      country: 'Kiribati',
      code: 'KI',
      continent: 'Oceania',
      name: '🇰🇮 KI',
      ko: '키리바시'
    },
    {
      country: 'Saint Vincent and the Grenadines',
      code: 'VC',
      continent: 'North America',
      name: '🇻🇨 VC',
      ko: '세인트빈센트 그레나딘'
    },
    {
      country: 'Grenada',
      code: 'GD',
      continent: 'North America',
      name: '🇬🇩 GD',
      ko: '그레나다'
    },
    {
      country: 'Aruba',
      code: 'AW',
      continent: 'North America',
      name: '🇦🇼 AW',
      ko: '아루바'
    },
    {
      country: 'Micronesia, Federated States of',
      code: 'FM',
      continent: 'Oceania',
      name: '🇫🇲 FM',
      ko: '미크로네시아'
    },
    {
      country: 'Antigua and Barbuda',
      code: 'AG',
      continent: 'North America',
      name: '🇦🇬 AG',
      ko: '앤티가 바부다'
    },
    {
      country: 'Jersey',
      code: 'JE',
      continent: 'Europe',
      name: '🇯🇪 JE',
      ko: '저지'
    },
    {
      country: 'Tonga',
      code: 'TO',
      continent: 'Oceania',
      name: '🇹🇴 TO',
      ko: '통가'
    },
    {
      country: 'Andorra',
      code: 'AD',
      continent: 'Europe',
      name: '🇦🇩 AD',
      ko: '안도라'
    },
    {
      country: 'US Virgin Islands',
      code: 'VI',
      continent: 'North America',
      name: '🇻🇮 VI',
      ko: '미국령 버진아일랜드'
    },
    {
      country: 'Cayman Islands',
      code: 'KY',
      continent: 'North America',
      name: '🇰🇾 KY',
      ko: '케이맨 제도'
    },
    {
      country: 'Isle of Man',
      code: 'IM',
      continent: 'Europe',
      name: '🇮🇲 IM',
      ko: '맨섬'
    },
    {
      country: 'Dominica',
      code: 'DM',
      continent: 'North America',
      name: '🇩🇲 DM',
      ko: '도미니카'
    },
    {
      country: 'Guernsey',
      code: 'GG',
      continent: 'Europe',
      name: '🇬🇬 GG',
      ko: '건지'
    },
    {
      country: 'Bermuda',
      code: 'BM',
      continent: 'North America',
      name: '🇧🇲 BM',
      ko: '버뮤다'
    },
    {
      country: 'Greenland',
      code: 'GL',
      continent: 'North America',
      name: '🇬🇱 GL',
      ko: '그린란드'
    },
    {
      country: 'Faroe Islands',
      code: 'FO',
      continent: 'Europe',
      name: '🇫🇴 FO',
      ko: '페로 제도'
    },
    {
      country: 'Saint Kitts and Nevis',
      code: 'KN',
      continent: 'North America',
      name: '🇰🇳 KN',
      ko: '세인트키츠 네비스'
    },
    {
      country: 'Turks and Caicos Islands',
      code: 'TC',
      continent: 'North America',
      name: '🇹🇨 TC',
      ko: '터크스 케이커스 제도'
    },
    {
      country: 'American Samoa',
      code: 'AS',
      continent: 'Oceania',
      name: '🇦🇸 AS',
      ko: '미국령 사모아'
    },
    {
      country: 'Northern Mariana Islands',
      code: 'MP',
      continent: 'Oceania',
      name: '🇲🇵 MP',
      ko: '북마리아나 제도'
    },
    {
      country: 'Marshall Islands',
      code: 'MH',
      continent: 'Oceania',
      name: '🇲🇭 MH',
      ko: '마셜 제도'
    },
    {
      country: 'Sint Maarten (Dutch part)',
      code: 'SX',
      continent: 'North America',
      name: '🇸🇽 SX',
      ko: '신트마르턴'
    },
    {
      country: 'Liechtenstein',
      code: 'LI',
      continent: 'Europe',
      name: '🇱🇮 LI',
      ko: '리히텐슈타인'
    },
    {
      country: 'British Virgin Islands',
      code: 'VG',
      continent: 'North America',
      name: '🇻🇬 VG',
      ko: '영국령 버진아일랜드'
    },
    {
      country: 'Monaco',
      code: 'MC',
      continent: 'Europe',
      name: '🇲🇨 MC',
      ko: '모나코'
    },
    {
      country: 'Gibraltar',
      code: 'GI',
      continent: 'Europe',
      name: '🇬🇮 GI',
      ko: '지브롤터'
    },
    {
      country: 'San Marino',
      code: 'SM',
      continent: 'Europe',
      name: '🇸🇲 SM',
      ko: '산마리노'
    },
    {
      country: 'Saint Martin (French part)',
      code: 'MF',
      continent: 'North America',
      name: '🇲🇫 MF',
      ko: '세인트마틴'
    },
    {
      country: 'Alland Islands',
      code: 'AX',
      continent: 'Europe',
      name: '🇦🇽 AX',
      ko: '올란드 제도'
    },
    {
      country: 'Palau',
      code: 'PW',
      continent: 'Oceacia',
      name: '🇵🇼 PW',
      ko: '팔라우'
    },
    {
      country: 'Anguilla',
      code: 'AI',
      continent: 'North America',
      name: '🇦🇮 AI',
      ko: '앵귈라'
    },
    {
      country: 'Cook Islands',
      code: 'CK',
      continent: 'Oceania',
      name: '🇨🇰 CK',
      ko: '쿡 제도'
    },
    {
      country: 'Nauru',
      code: 'NR',
      continent: 'Oceania',
      name: '🇳🇷 NR',
      ko: '나우루'
    },
    {
      country: 'Wallis and Futuna',
      code: 'WF',
      continent: 'Oceania',
      name: '🇼🇫 WF',
      ko: '월리스 푸투나'
    },
    {
      country: 'Tuvalu',
      code: 'TV',
      continent: 'Oceania',
      name: '🇹🇻 TV',
      ko: '투발루'
    },
    {
      country: 'Saint Barthelemy',
      code: 'BL',
      continent: 'North America',
      name: '🇧🇱 BL',
      ko: '생바르텔레미'
    },
    {
      country: 'Saint Pierre and Miquelon',
      code: 'PM',
      continent: 'North America',
      name: '🇵🇲 PM',
      ko: '생피에르 미클롱'
    },
    {
      country: 'Saint Helena',
      code: 'SH',
      continent: 'Africa',
      name: '🇸🇭 SH',
      ko: '세인트헬레나'
    },
    {
      country: 'Montserrat',
      code: 'MS',
      continent: 'North America',
      name: '🇲🇸 MS',
      ko: '몬트세랫'
    },
    {
      country: 'Falkland Islands (Malvinas)',
      code: 'FK',
      continent: 'South America',
      name: '🇫🇰 FK',
      ko: '포클랜드 제도'
    },
    {
      country: 'Tokelau',
      code: 'TK',
      continent: 'Oceania',
      name: '🇹🇰 TK',
      ko: '토켈라우'
    },
    {
      country: 'Svalbard and Jan Mayen',
      code: 'SJ',
      continent: 'Antarctica',
      name: '🇸🇯 SJ',
      ko: '스발바르 얀마옌'
    },
    {
      country: 'Norfolk Island',
      code: 'NF',
      continent: 'Oceania',
      name: '🇳🇫 NF',
      ko: '노퍽 섬'
    },
    {
      country: 'Christmas Island',
      code: 'CX',
      continent: 'Asia',
      name: '🇨🇽 CX',
      ko: '크리스마스 섬'
    },
    {
      country: 'Niue',
      code: 'NU',
      continent: 'Oceania',
      name: '🇳🇺 NU',
      ko: '니우에'
    },
    {
      country: 'Antarctica',
      code: 'AQ',
      continent: 'Antarctica',
      name: '🇦🇶 AQ',
      ko: '남극'
    },
    {
      country: 'Holy See (Vatican City State)',
      code: 'VA',
      continent: 'Europe',
      name: '🇻🇦 VA',
      ko: '바티칸'
    },
    {
      country: 'Cocos (Keeling) Islands',
      code: 'CC',
      continent: 'Asia',
      name: '🇨🇨 CC',
      ko: '코코스 제도'
    },
    {
      country: 'French Southern Territories',
      code: 'TF',
      continent: 'Antarctica',
      name: '🇹🇫 TF',
      ko: '프랑스령 남부 지역'
    },
    {
      country: 'Pitcairn',
      code: 'PN',
      continent: 'Oceania',
      name: '🇵🇳 PN',
      ko: '피트케언'
    },
    {
      country: 'Bouvet Island',
      code: 'BV',
      continent: 'Antarctica',
      name: '🇧🇻 BV',
      ko: '부베 섬'
    },
    {
      country: 'British Indian Ocean Territory',
      code: 'IO',
      continent: 'Antarctica',
      name: '🇮🇴 IO',
      ko: '영국령 인도양 지역'
    },
    {
      country: 'Heard Island and McDonald Islands',
      code: 'HM',
      continent: 'Antarctica',
      name: '🇭🇲 HM',
      ko: '허드 맥도널드 제도'
    },
    {
      country: 'South Georgia and the South Sandwich Islands',
      code: 'GS',
      continent: 'Antarctica',
      name: '🇬🇸 GS',
      ko: '사우스조지아 사우스샌드위치 제도'
    }
  
];
